export const formatCurrency = (amount: number, options?: { compact?: boolean }) => {
  // Check if the number has any decimal places
  const hasDecimals = amount % 1 !== 0;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: options?.compact ? 0 : 2,
    ...(options?.compact && { notation: 'compact', compactDisplay: 'short' }),
  }).format(amount);
};
